import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import colors from '../Constant/colors';

const StudentAttendance = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "#ffffff",
    padding: "20px",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minHeight: "120px",
    transition: "0.3s",
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
  };

  const subText = {
    fontSize: "12px",
    color: colors.grayDark,
    opacity: 0.85,
    marginTop: "2px",
  };

  const iconStyle = {
    fontSize: "32px",
    minWidth: "40px",
  };

  const titleStyle = {
    fontWeight: "700",
    color: colors.grayDark,
  };

  return (
    <div className="flex justify-center items-start p-6 bg-white min-h-screen">
      <div className="w-full max-w-7xl">
        {/* Page Header */}
      

        {/* Grid */}
        <div className={`grid gap-6 ${isMobile ? "grid-cols-1" : "grid-cols-3"}`} style={{ alignItems: "stretch" }}>
          
          {/* Add Attendance */}
          <Link to="/add-attendance" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i className="fas fa-id-badge" style={{ ...iconStyle, color: "#8B5CF6" }}></i>
              <div>
                <h2 style={heading}>Add Attendance</h2>
                <p style={subText}>Here you can add attendance.</p>
              </div>
            </div>
          </Link>

          {/* View Attendance */}
          <Link to="/view-attendance" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i className="fas fa-users-viewfinder" style={{ ...iconStyle, color: "#3B82F6" }}></i>
              <div>
                <h2 style={heading}>View Attendance</h2>
                <p style={subText}>View all students' attendance records.</p>
              </div>
            </div>
          </Link>


        </div>
      </div>
    </div>
  );
};

export default StudentAttendance;
